import React, { useState, useEffect, useCallback, useRef } from 'react';
import './generate-doc.scss';
import { Button } from 'devextreme-react/button';
import {getDocumentById} from '../../api/api'
import { useAuth } from '../../contexts/auth';
import notify from 'devextreme/ui/notify';
import { useNavigate, useParams } from 'react-router-dom';
import { LoadIndicator } from 'devextreme-react/load-indicator';

export default function GenerateDocPrint() {
  const { user, refreshSession } = useAuth();
  let { document_id } = useParams();
  const navigate = useNavigate();

  const editorRef = useRef(null);

  const [htmlData, setHtmlData] = useState(null);
  const [loading, setLoading] = useState(true);

  const onError = useCallback((error) => {
    if (error.status === 401) {
      refreshSession();
    } else {
      notify("An error has occured. Please try again later.", 'error', 2000);
      setLoading(false);
      console.log(error);
    }
  }, [refreshSession]);

  const onDocumentDataSuccess = useCallback((data) => {
    setHtmlData(data.html)
    setLoading(false);
  }, [])

  const onPrint = useCallback(() => {
    window.print();
  }, [])

  useEffect(() => {
    if (user.signInUserSession) {
      getDocumentById(user, document_id, onDocumentDataSuccess, onError)
    }
  }, [user, document_id, onDocumentDataSuccess, onError]);



  return (
    <React.Fragment>
      {loading?
      <div className="d-flex flex-row justify-content-center align-items-center mt-5 pt-5">
          <LoadIndicator
              id="large-indicator"
              height={60}
              width={60}
          />
      </div>
      :
      <div className="d-flex flex-column">

        <div className="d-flex flex-row justify-content-between align-items-end d-print-none">
          <div className="pe-3" style={{minWidth:"60%"}}>
            <h2 className={'content-block'}>Generate Document</h2>
          </div>
          <Button
              text="Cancel"
              icon="fas fa-chevron-left"
              onClick={() => {navigate("/templates")}}
          />
          <Button
              text="Edit"
              icon="fas fa-pen"
              onClick={() => {navigate("/generate/edit/"+document_id)}}
          />
          <Button
              text="Print"
              icon="fas fa-print"
              onClick={onPrint}
          />
        </div>
        <hr className="d-print-none"/>
        <div className="print-preview" ref={editorRef} dangerouslySetInnerHTML={{ __html: htmlData }}/>



      </div>}

    </React.Fragment>
)}
